module.exports = "<horizontal-navigation-bar></horizontal-navigation-bar>\n<div class=\"container-fluid\" id=\"settings\">\n    <div class=\"row isFlex\">\n        <div class=\"col-md-2 sideBar\">\n            <asui-vertical-navbar ng-model=\"$ctrl.navigationService.selectedSubState\" items=\"$ctrl.settingsItems\"></asui-vertical-navbar>\n        </div>\n        <div class=\"col-md-10\">\n            <div ui-view></div>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./modules/settings/components/settings/settings.component.html
// module id = 653
// module chunks = 0